// TODO -> This component to be removed when the anniversaryBasedTimeOff flag is deprecated
import React from "react";
import { differenceInDays } from "date-fns";

import LeaveType from "components/Screens/Timeoff/ManageTimeoff/Common/LeaveType";
import EditByHrStatus from "components/Screens/Timeoff/ManageTimeoff/Common/EditByHrStatus";
import ChipComp from "components/common/Chip";

function TimeoffBreakdownLegacy({
  pending,
  collapsed,
  noOfLeaves,
  dateFrom,
  createdAt,
  leaveStatus,
  leaveType,
  hrEdit,
  hrApproved,
  country,
  status,
  scheduleTextClass,
}) {
  return (
    <div className={pending || !collapsed ? "pending-timeoff-details-wrapper" : "space-y-1 pb-1"}>
      <div className="pending-timeoff-details">
        <div
          className={pending || !collapsed ? "pending-timeoff-details-text" : scheduleTextClass}
          id="total-timeoff-used"
        >
          Duration
        </div>
        <div className={pending || !collapsed ? "timeoff-breakdown-chip" : "timeoff-breakdown-chip-scheduled"}>
          <ChipComp
            variant="outlined"
            id="no-of-leaves"
            labelClass="para-body-s-regular"
            label={`${noOfLeaves} ${noOfLeaves === 1 ? "leave" : "leaves"}`}
          />
        </div>
      </div>

      <div className="pending-timeoff-details">
        <div className={pending || !collapsed ? "pending-timeoff-details-text" : scheduleTextClass}>Notice Period</div>
        <div className={pending || !collapsed ? "timeoff-breakdown-chip" : "timeoff-breakdown-chip-scheduled"}>
          <ChipComp
            variant="outlined"
            labelClass="para-body-s-regular"
            id="notice-period"
            label={`${differenceInDays(new Date(dateFrom), new Date(createdAt))} Days`}
          />
        </div>
      </div>

      <div className="pending-timeoff-details">
        <div className={pending || !collapsed ? "pending-timeoff-details-text" : scheduleTextClass}>Status</div>
        <span className={pending || !collapsed ? "" : "ml-1"}>
          <LeaveType type={pending ? "Pending" : leaveStatus} />{" "}
        </span>
      </div>

      {country === "Peru" && (leaveType === "Sick" || hrEdit || hrApproved) && (
        <div className="pending-timeoff-details">
          <div className={pending || !collapsed ? "pending-timeoff-details-text" : scheduleTextClass}>
            HR doc review
          </div>
          <EditByHrStatus
            style={{ width: "fit-content !important" }}
            hrEdit={hrEdit}
            hrApproved={hrApproved}
            leaveStatus={status}
          />
        </div>
      )}
    </div>
  );
}

export default TimeoffBreakdownLegacy;
